import { useState } from 'react'

import { NICHT_VORHANDEN, api, ohne404 } from '../api'
import { useAktion, useLaden } from '../hooks'
import { RECHENBASEN } from '../typen'
import type { Rechenbasis, RechenbasisEinstellung } from '../typen'
import Meldungen from './Meldungen'

/** Der Titel einer Rechenbasis in Worten - unsere Beschriftung, sonst die des Backends, sonst der Wert. */
export function rechenbasisTitel(wert: string, einstellung?: RechenbasisEinstellung | null): string {
  return RECHENBASEN.find((r) => r.wert === wert)?.titel ?? einstellung?.moeglich[wert] ?? wert
}

/**
 * Die Rechenbasis für alle (02.11.2026, `GET/PUT /api/disposition/rechenbasis`): womit Disposition, Heute,
 * Fällig-Liste, Export und Assistent rechnen, wenn niemand eine nennt. Frau Barth am 27.10.2026: „Bitte immer
 * mit den tatsächlichen monatlichen Produktionszahlen 2025/2026 rechnen“ - zugesagt im Gespräch, nie gespeichert.
 *
 * Getrennt von der Auswahl auf dem Dispositionsblatt: die gilt nur für die Ansicht in diesem Browser-Tab.
 */
export default function RechenbasisStandard() {
  const [auswahl, setAuswahl] = useState<Rechenbasis | null>(null)
  const { fehler, erfolg, arbeitet, setErfolg, ausfuehren } = useAktion()
  const { daten, fehler: ladeFehler, setDaten } = useLaden(() => ohne404(api.rechenbasisStandard()), [])

  if (daten === NICHT_VORHANDEN) return <p className="hinweis">Diese Einstellung kennt das Backend noch nicht.</p>
  const wert = auswahl ?? daten?.rechenbasis ?? ''

  function speichern() {
    if (!auswahl) return
    void ausfuehren(async () => {
      const neu = await api.rechenbasisStandardSetzen(auswahl)
      setDaten(neu)
      setAuswahl(null)
      setErfolg(`Gerechnet wird jetzt mit: ${rechenbasisTitel(neu.rechenbasis, neu)}.`)
    })
  }

  return (
    <div className="karte">
      <Meldungen fehler={ladeFehler ?? fehler} erfolg={erfolg} />
      <div className="leiste">
        <label className="feld">
          <span className="hinweis">Rechenbasis für alle</span>
          <select value={wert} disabled={!daten} onChange={(e) => setAuswahl(e.target.value as Rechenbasis)}>
            {RECHENBASEN.map((r) => (
              <option key={r.wert} value={r.wert}>
                {r.titel}
                {daten && r.wert === daten.standard ? ' (Vorgabe)' : ''}
              </option>
            ))}
          </select>
        </label>
        <button className="haupt" disabled={arbeitet || !auswahl || auswahl === daten?.rechenbasis} onClick={speichern}>
          Speichern
        </button>
      </div>
      <p className="hinweis" style={{ marginBottom: 0 }}>
        Womit die maßgebliche Reichweite gerechnet wird, wenn niemand etwas anderes wählt: Dispositionsblatt, Heute,
        Fällig-Liste, Excel-Export und Assistent. Die Auswahl auf dem Dispositionsblatt gilt nur für die eigene Ansicht.
      </p>
    </div>
  )
}
